// External
import { combineReducers } from "@reduxjs/toolkit";

// Reducers
import answersReducer from "./answers";
import navigationReducer from "./navigation";
import questionsReducer from "./questions";
import matchesReducer from "./matches";
// Setup the Root Reducer for Redux
const rootReducer = combineReducers({
	answers: answersReducer,
	navigation: navigationReducer,
	questions: questionsReducer,
	matches: matchesReducer,
});

// Exports
export default rootReducer;
